import { initializeApp } from 'firebase/app';

firebasePromiseResolved(initializeApp(firebaseConfig));
